<template>
  <div class="flex">
    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="pdfShow"
      width="800px"
      v-if="pdfShow"
    >
      <div class="scroll-y" style="height: 60vh;">
        <pdf :src="fileUrl" :page="page"></pdf>
      </div>
      <div class="full-width flex justify-around">
        <el-button :disabled="page <= 1" @click.stop="page--">上一页</el-button>
        <el-button @click.stop="page++">下一页</el-button>
      </div>
    </el-dialog>

    <div :class="!isReady && percentage == 0 ? 'singer-file-upload' : ''">
      <el-upload
        ref="elUpload"
        :action="action"
        :headers="header"
        :before-upload="beforeUpload"
        class="avatar-uploader"
        :limit="1"
        :accept="suffixList.join(',')"
        :multiple="false"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadFailed"
        :on-progress="uploadProgress"
      >
        <audio
          :src="fileUrl"
          v-if="isReady && ['.mp3', '.wav', '.flac'].indexOf(suffix) >= 0"
          controls
        ></audio>
        <video
          width="100%"
          :src="fileUrl"
          v-else-if="isReady && ['.mp4', '.avi', '.mkv'].indexOf(suffix) >= 0"
          controls
        ></video>
        <img
          style="max-width: 50%;"
          :src="fileUrl"
          v-else-if="isReady && ['.jpg', '.png', '.jpeg'].indexOf(suffix) >= 0"
        ></img>
        <el-button
          v-else-if="isReady && ['.pdf'].indexOf(suffix) >= 0"
          @click.stop="pdfShow = true"
        >
          点击查看
        </el-button>

        <div v-else>
          <el-progress
            v-if="percentage > 0"
            type="circle"
            :percentage="percentage"
          ></el-progress>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </div>
      </el-upload>
    </div>
    <i
      v-if="fileUrl && isReady"
      class="el-icon-delete avatar-uploader-icon"
      @click="handleRemove"
    ></i>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { getStorage } from '@/utils/storageUtils.js';
import {
  startLoading,
  closeLoading,
  showSuccessMsg,
  showErrorMsg,
} from '@/utils/uiUtils.js';

export default {
  components: {
    pdf,
  },

  data() {
    return {
      page: 1,
      pdfShow: false,
      fileUrl: this.file,
      suffix: '',
      fileData: null,
      uploadRes: '',
      isReady: false,
      percentage: 0,
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    size: {
      type: Number,
      default: 178,
    },

    disabledMsg: {
      type: String,
      default: '',
    },

    header: {
      type: Object,
      default: function() {
        return {
          Authorization: 'Bearer ' + getStorage('token'),
        };
      },
    },

    action: {
      type: String,
      default: '',
    },

    file: {
      type: String,
      default: '',
    },

    maxSize: {
      type: Number,
      default: 50 * 1024,
    },

    suffixList: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },

  watch: {
    file: function(newVal) {
      this.fileUrl = newVal;
      let suffixList = newVal.split('.');
      this.suffix = '.' + suffixList[suffixList.length - 1];
      this.isReady = true;
    },
  },

  mounted() {
    if (this.file) {
      this.fileUrl = this.file;
      let suffixList = this.file.split('.');
      this.suffix = '.' + suffixList[suffixList.length - 1];
      this.isReady = true;
    }
  },

  methods: {
    handleRemove: function(file, fileList) {
      this.reset();
    },

    uploadProgress: function(event, file, fileList) {
      this.percentage = parseInt(event.percent);
    },

    beforeUpload: function(file) {
      this.isReady = false;
      this.percentage = 0;
      if (this.disabled) {
        if (this.disabledMsg) {
          showErrorMsg(this.disabledMsg);
        } else {
          showErrorMsg('暂不可用');
        }
        this.$emit('disableFunc');
        return false;
      }

      let isSuffixOk = false;

      if (this.suffixList.length) {
        for (let index in this.suffixList) {
          if (file.name.endsWith(this.suffixList[index])) {
            this.suffix = this.suffixList[index];
            isSuffixOk = true;
            break;
          }
        }
      } else {
        isSuffixOk = true;
      }

      if (!isSuffixOk) {
        showErrorMsg('仅支持以下文件格式:' + this.suffixList);
        return false;
      }

      if (this.maxSize > 0) {
        const isLt = file.size / 1024 / 1024 < this.maxSize;
        if (!isLt) {
          showErrorMsg('上传文件大小不能超过' + this.maxSize + 'M');
          return false;
        }
      }
      startLoading();
      return true;
    },

    uploadSuccess: function(response, file, fileList) {
      this.uploadRes = response.data;
      this.fileData = file.raw;
      this.fileUrl = URL.createObjectURL(file.raw);
      this.isReady = true;
      closeLoading();
      showSuccessMsg('上传成功');
      this.$emit('success', file);
    },

    uploadFailed: function(err, file, fileList) {
      console.error(err);
      this.fileUrl = '';
      this.fileData = null;
      this.filename = '';
      closeLoading();
      this.isReady = false;
      try {
        showErrorMsg(JSON.parse(err.message).err_msg);
      } catch (e) {
        showErrorMsg('上传失败');
      }
      this.$emit('error');
    },

    reset: function() {
      this.fileUrl = '';
      this.fileData = null;
      this.isReady = false;
      this.percentage = 0;
      this.filename = '';
      this.inputFile = '';
      this.$refs.elUpload.clearFiles();
      this.$forceUpdate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/upload/mediaUpload.vue